import { useState, useEffect } from 'react';
import { getArticles } from '../SpotlightWidget/utils';
import { useArticlesEnabled } from '~SpectateStore/hooks/clientStateHooks';
const ARTICLE_TYPE = 'article';

export const useLongArticleData = ({
    sportSlug,
    eventId,
} = {}) => {
    const [longArticleData, setLongArticleData] = useState({});
    const articlesEnabled = useArticlesEnabled();

    useEffect(() => {
        if (articlesEnabled) {
            getArticles(sportSlug, eventId, ARTICLE_TYPE).then(data => {
                setLongArticleData(data);
            });
        }

        // Cleanup data before execution of useEffect
        // This is mainly needed for the "Change Event" dropdpwn on the event page
        return () => setLongArticleData({});
    }, [sportSlug, eventId]);

    return longArticleData;
};
